<template>
    <svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
        <image :href="logo" x="0" y="0" width="90" height="90" preserveAspectRatio="xMidYMid meet" />
    </svg>
</template>
<script>
import logo from '@/assets/images/logo-validateiq-white.png';

export default {
    data() {
        return { logo };
    }
};
</script>
